import { Data_getInstancejzfc9afmx30l as Data_getInstance } from './adapter/DeletePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeletePairAssignmentsMutationSelections_getInstanceatco19s8qtev as DeletePairAssignmentsMutationSelections_getInstance } from './selections/DeletePairAssignmentsMutationSelections.mjs';
import { DeletePairAssignmentsMutation_VariablesAdapter_instance1geqbpcg2iie7 as DeletePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/DeletePairAssignmentsMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePairAssignments) {
        this.v6d_1 = deletePairAssignments;
      }
      toString() {
        return 'Data(deletePairAssignments=' + this.v6d_1 + ')';
      }
      hashCode() {
        return this.v6d_1 == null ? 0 : getBooleanHashCode(this.v6d_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.v6d_1 == other.v6d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w6d_1 = obj(Data_getInstance());
        this.x6d_1 = (new (Builder())('data', Companion_getInstance().n6d_1)).q43(DeletePairAssignmentsMutationSelections_getInstance().a6e_1).i37();
        this.y6d_1 = '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
        this.z6d_1 = 'deletePairAssignments';
      }
      q6d() {
        return 'mutation deletePairAssignments($input: DeletePairAssignmentsInput!) { deletePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeletePairAssignmentsMutationClass;
function DeletePairAssignmentsMutation() {
  if (DeletePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.b6e_1 = input;
      }
      s6d() {
        return '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
      }
      operationId() {
        return this.s6d();
      }
      i47() {
        return Companion_getInstance_0().q6d();
      }
      t6d() {
        return 'deletePairAssignments';
      }
      operationName() {
        return this.t6d();
      }
      n46(writer, customScalarAdapters, withDefaultValues) {
        DeletePairAssignmentsMutation_VariablesAdapter_instance.c6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      m46() {
        return Companion_getInstance_0().w6d_1;
      }
      toString() {
        return 'DeletePairAssignmentsMutation(input=' + this.b6e_1.toString() + ')';
      }
      hashCode() {
        return this.b6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePairAssignmentsMutation()))
          return false;
        if (!this.b6e_1.equals(other.b6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    DeletePairAssignmentsMutationClass = $;
  }
  return DeletePairAssignmentsMutationClass;
}
//region block: exports
export {
  Data as Data245eeyny59bq1,
  DeletePairAssignmentsMutation as DeletePairAssignmentsMutationfwlgebyv0y4l,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsMutation.mjs.map
